<template lang="pug">
  .lg_container
    <global-header></global-header>
    .banner_container
      img(v-if="!websiteInfo.courseBannerFlag && websiteInfo.courseBannerUrlList && websiteInfo.courseBannerUrlList.length > 0" :src="websiteInfo.courseBannerUrlList[0]")
      img(v-else src="@/assets/banner/course_system.png")
    //- 十大课程体系
    //.student_box
    //  img.title(src="@/assets/course_system/system.png")
    //  p.title 让孩子在每一阶段都有扎实明显的进步
    //  img.course(src="@/assets/course_system/eight.png")
    //- 四大特色
    .student_box
      img.title(src="@/assets/course_system/feature.png")
      .feature_box.first
        .feature_left
          img(src="@/assets/course_system/ts1.png")
        .feature_right
          h3.color1 二语习得式
          .content
            span 践行美国语言教育家克拉申提出的
            span.color1 第二语言习得理论
            span ，用科学高效的方法指导孩子学好第二语言。
      .feature_box.feature_box2
        .feature_left
          img(src="@/assets/course_system/ts2.png")
        .feature_right
          h3.color2 母语浸泡式
          .content
            span 打造
            span.color2 情景浸泡式
            span 学习环境，
            span.color2 符合国际倡导
            span 的第二语言科学学习法， 让孩子
            span.color2 自然习得语言技能
      .feature_box
        .feature_left
          img(src="@/assets/course_system/ts3.png")
        .feature_right
          h3.color3 趣味输入式
          .content
            span 通过大量夸张有趣的面部表情、肢体语言和教具，帮助孩子
            span.color3 更快速形象地
            span 理解课堂场景，
            span.color3 高效掌握
      .feature_box.feature_box2
        .feature_left
          img(src="@/assets/course_system/ts4.png")
        .feature_right
          h3.color4 高频交互式
          .content
            span 根据
            span.color4 德国著名心理学家
            span 艾宾浩斯提出的遗忘曲线，
            span.color4 科学设置
            span 重点场景的理解，
            span.color4 巩固孩子记忆力
      van-button.appoint_btn(round block type="primary" color="#FC6720" @click="onAppointment") 立即预约试听线上课
    //- 为什么选择
    .student_box
      img.title(src="@/assets/course_system/why.png")
      p.title 欧美外教AI双师课
      .swiper-container
        .swiper-wrapper
          .swiper-slide
            img(src="@/assets/course_system/1.jpg")
            h3 采用英国原版独家进口动画英文课
            p 10万英美幼儿园及小学标配英文教材涵盖我国小学6年90%的英文知识点
          .swiper-slide
            img(src="@/assets/course_system/2.png")
            h3 课程符合不同年龄段孩子认知特点，
            p 课程设计符合儿童心理学和行为学特点内容环环相扣、层层递进，稳步提高英语能力
          .swiper-slide
            img(src="@/assets/course_system/3.png")
            h3 引进美国STEAM教育体系
            p 教学成效紧扣义务教育新课标培养孩子综合素质，提升全球竞争力
          .swiper-slide
            img(src="@/assets/course_system/4.png")
            h3 知名双师师资
            p Tesol国际英语教师专业认证16年少儿英语启蒙教育经验
          .swiper-slide
            img(src="@/assets/course_system/5.jpg")
            h3 10余年少儿英语教培市场调研成果
            p 遵循“先语后文，自然习得”的第二语言学习法已帮助10w+学员轻松掌握英语技能
        .swiper-pagination
    <global-footer ref="globalFoot"></global-footer>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import Swiper from 'swiper'
export default {
  name: 'CourseSystem',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  computed: {
    ...mapGetters([
      'websiteInfo'
    ])
  },
  data() {
    return {
      mySwiper: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mySwiper = new Swiper('.swiper-container', {
        loop: true,
        autoplay: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        loopAdditionalSlides: 100,
        pagination: {
          el: '.swiper-pagination'
        }
      })
    })
  },
  methods: {
    // 预约
    onAppointment() {
      this.$refs.globalFoot.show()
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('~@/styles/swiper.min.css');
.lg_container {
  overflow: hidden;
  .student_box {
    padding: 0 20px;
    margin-bottom: 10px;
    position: relative;
    > img.title {
      height: 23px;
      margin-top: 30px;
    }
    > p.title {
      color: #666a72;
      font-size: 14px;
    }
    .course {
      width: 100%;
      margin-top: 30px;
    }
    .feature_box {
      display: flex;
      align-items: center;
      box-shadow: 0px 0px 6px 0px rgba(215, 215, 215, 0.5);
      border-radius: 10px;
      padding: 18px;
      margin-bottom: 15px;
      &.first {
        margin-top: 30px;
      }
      &.feature_box2 {
        .feature_left {
          order: 1;
          margin-right: 0;
          margin-left: 16px;
        }
      }
      .feature_left {
        width: 88px;
        height: 88px;
        background: rgba(217, 217, 217, 0.2);
        border-radius: 50%;
        overflow: hidden;
        margin-right: 16px;
        img {
          width: 74px;
          height: 74px;
          margin-top: 7px;
          margin-left: 7px;
          border-radius: 50%;
          overflow: hidden;
        }
      }
      .feature_right {
        flex: 1;
        .color1 {
          color: #f4c720;
        }
        .color2 {
          color: #70ca6c;
        }
        .color3 {
          color: #fe8214;
        }
        .color4 {
          color: #1b9aef;
        }
        h3 {
          font-size: 18px;
          margin-bottom: 10px;
        }
        .content {
          color: #333333;
          font-size: 13px;
          span {
            line-height: 20px;
          }
        }
      }
    }
    .appoint_btn {
      font-size: 18px;
      margin-top: 30px;
    }
    .swiper-container {
      width: 100%;
      height: 260px;
      overflow: visible !important;
      position: relative;
      margin-bottom: 60px;
      margin-top: 20px;
      .swiper-wrapper {
        .swiper-slide {
          width: 310px;
          height: 260px;
          background: #fffaf3;
          box-shadow: 0px 2px 6px 0px rgba(246, 207, 169, 0.9);
          border-radius: 10px;
          padding: 10px;
          img {
            width: 100%;
            height: 150px;
            object-fit: cover;
            border-radius: 6px;
          }
          h3 {
            color: #333333;
            font-size: 16px;
            margin: 18px 0 9px;
            font-weight: bold;
            text-align: center;
          }
          p {
            padding: 0 12px 0 18px;
            color: #333333;
            font-size: 13px;
            line-height: 20px;
          }
        }
      }
      .swiper-pagination {
        bottom: -50px;
      }
    }
  }
}
::v-deep .swiper-pagination-bullet {
  background-color: #efefef;
  opacity: 1;
}
::v-deep .swiper-pagination-bullet-active {
  background-color: #a7a7a7;
}
</style>
